import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Result, Spin } from 'antd';
import api from '../utils/api';
import { updateZoneStore } from './Store';
import { updateQueueStore } from './Store/queueStore';
import { clearSelection } from './Store/selectionStore';
import Header from './views/Header';
import BuilderLayout from './views/BuilderLayout';

function CurrentZone() {
  const zoneId = Number(useParams().id);
  const [status, setStatus] = useState('loading');
  const [errMessage, setErrMessage] = useState('');

  async function fetchZone() {
    setStatus('loading');

    const [zoneRes, queueData] = await Promise.all([
      api.getCurrentZone(zoneId),
      api.getQueue(),
    ]);

    if (!zoneRes.status) {
      setErrMessage(zoneRes.errMessage);
      setStatus('error');
      return;
    }

    updateZoneStore({ ...zoneRes.data });
    updateQueueStore({ queue: queueData?.data || [] });
    clearSelection();
    setStatus('ready');
  }

  useEffect(() => {
    fetchZone();
  }, [zoneId]);

  if (status === 'loading') {
    return <Spin size="large" style={{ display: 'block', margin: '80px auto' }} />;
  }

  if (status === 'error') {
    return <Result status="error" title="Зона недоступна" subTitle={errMessage} />;
  }

  return (
    <>
      <Header />
      <BuilderLayout />
    </>
  );
}

export default CurrentZone;
